import Cookies from 'js-cookie';
import $ from 'jquery';

// if no cookie and no homepage pls no logo 
if ( Cookies.get( 'user_visit' ) == 'false' || $( 'body.home' ).length  ) {
  $( '.flipp-large' ).show();
}

// // preloader
// Remove scrolling while the preloader carries out
// $( 'body' ).addClass('no-scroll-preload')
// $(  window ).on(  'load', function(   ) {
//   // give preloader time to load then remove body no scroll
//   setTimeout(function() {
//     $( 'body' ).removeClass('no-scroll-preload');
// }, 1900);
// })

if (  $( 'body.home' ).length ) {
  // If it is the homepage show the loader
  var cookie30Min = 1 / 48;
  let heroVideo = document.getElementById('hero-video');

  //create the cookie
  Cookies.set(  'user_visit', 'true', {//'name' , 'value' pair
    expires: cookie30Min,
    secure: true //must read on an HTTPS
  });

  $(  window ).on( 'load', function() {
    $( '.load-container' ).addClass( 'animate-swap' );
    $( '.load-container' ).delay( 1450 ).fadeOut( 50 );
    $( '#overlayer' ).delay( 1500 ).fadeOut( 400 );

    if( $( '#hero-video' ).length ){
      setTimeout( () => {
        heroVideo.play();
      }, 1700);
    }
  });
} else if ( Cookies.get( 'user_visit' ) == 'true' ) {

  //if theres the cookie 'user_visit' exsisting, dont show the loader
  $( window ).on( 'load', function() {
    $( '.load-container' ).delay( 100 ).fadeOut( 50 );
    $( '#overlayer' ).delay( 150 ).fadeOut( 400 );

    if( $( '#hero-video' ).length ){
      setTimeout( () => {
        heroVideo.play();
      }, 250);
    }
  });
} else {

  // If theres no cookie named 'user_visit' then create it, and show the full loader
  //create a cookie that expires in 30 min
  var cookie30Min = 1 / 48;

  //create the cookie
  Cookies.set( 'user_visit', 'true', { //'name' , 'value' pair
    expires: cookie30Min,
    secure: true //must read on an HTTPS
  });

  $( window ).on( 'load', function() {
    $( '.load-container' ).addClass( 'animate-swap' );
    $( '.load-container' ).delay( 1450 ).fadeOut( 50 );
    $( '#overlayer' ).delay( 1500 ).fadeOut( 400 );
    
    if( $( '#hero-video' ).length ){
      setTimeout( () => {
        heroVideo.play();
      }, 1700);
    }
  });
}

var allLinks = document.querySelectorAll( 'a.nav-loader' );

allLinks.forEach( link => {
  $( link ).on( 'click', function( e ) {
    e.preventDefault();

    $( '#overlayer' ).fadeIn();

    setTimeout( function() {
      window.location = link.href;
    }, 500 );
  });
});
